module.exports = __webpack_public_path__ + "static/media/musee.5a7c9400.jpg";